import React, { useId } from 'react';
type FormFieldProps = {
  name: string;
  label: string;
  value: string;
  onChange: (value: string) => void;
  error?: string;
  type?: 'text' | 'email' | 'tel' | 'url' | 'textarea' | 'select';
  options?: string[];
  required?: boolean;
  placeholder?: string;
  hint?: string;
  autoComplete?: string;
  rows?: number;
  tone?: 'light' | 'dark';
  className?: string;
};
export function FormField({
  name,
  label,
  value,
  onChange,
  error,
  type = 'text',
  options = [],
  required,
  placeholder,
  hint,
  autoComplete,
  rows = 4,
  tone = 'light',
  className = ''
}: FormFieldProps) {
  const uid = useId();
  const id = `${name}-${uid}`;
  const descId = `${id}-desc`;
  const control = `w-full rounded-md border bg-white px-3.5 text-[15px] text-ink placeholder:text-muted/70 transition-[border-color,box-shadow] duration-150 focus:outline-none focus:ring-2 focus:ring-gold/40 ${error ? 'border-danger focus:border-danger' : 'border-line focus:border-midnight'}`;
  const common = {
    id,
    name,
    'aria-invalid': error ? true : undefined,
    'aria-required': required || undefined,
    'aria-describedby': error || hint ? descId : undefined
  };
  const labelColor = tone === 'dark' ? 'text-white' : 'text-ink';
  const subtle = tone === 'dark' ? 'text-white/60' : 'text-muted';
  return <div className={className} data-id="element-506" data-mp="21ynlrc9kob77">
      <label htmlFor={id} className={`mb-1.5 block text-sm font-medium ${labelColor}`} data-id="element-507" data-mp="2gx9adc1jw16p">
        {label}
        {required ? <span className="text-gold-700" aria-hidden="true" data-id="element-508" data-mp="2byy0j1b99qoh">
            {' '}
            *
          </span> : <span className={`font-normal ${subtle}`} data-id="element-509" data-mp="2pp1i3ez6ww7l"> (optional)</span>}
      </label>
      {type === 'textarea' ? <textarea {...common} rows={rows} value={value} placeholder={placeholder} onChange={e => onChange(e.target.value)} className={`${control} py-3`} data-id="element-510" data-mp="2lq2crt9jqxfm" /> : type === 'select' ? <select {...common} value={value} onChange={e => onChange(e.target.value)} className={`${control} h-12 cursor-pointer pr-3`} data-id="element-511" data-mp="2uqh00y62mmlr">
          <option value="" data-id="element-512" data-mp="1wcjut9x3xnh4">Select…</option>
          {options.map(o => <option key={o} value={o} data-id="element-513" data-mp="1wagvfza2ehzq">
              {o}
            </option>)}
        </select> : <input {...common} type={type} value={value} placeholder={placeholder} autoComplete={autoComplete} onChange={e => onChange(e.target.value)} className={`${control} h-12`} data-id="element-514" data-mp="262cx1kbd0q8p" />}
      {error ? <p id={descId} className={`mt-1.5 text-sm ${tone === 'dark' ? 'text-red-300' : 'text-danger'}`} data-id="element-515" data-mp="2k2e8tut5xi2y">
          {error}
        </p> : hint ? <p id={descId} className={`mt-1.5 text-xs ${subtle}`} data-id="element-516" data-mp="2p07feoydoe3r">
          {hint}
        </p> : null}
    </div>;
}